// themes.js
import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        // you can customize other palette colors here
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        // customize as needed
    },
});